import { render } from "./BoxGame.vue?vue&type=template&id=693c1354"
import script from "./BoxGame.vue?vue&type=script&lang=js"
export * from "./BoxGame.vue?vue&type=script&lang=js"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__